// extracted by mini-css-extract-plugin
export var formInfo = "fD_M5";
export var formInfo__image = "fD_M0";
export var formInfo__link = "fD_M4";
export var formInfo__list = "fD_M2";
export var formInfo__sectionHr = "fD_M3";
export var formInfo__services = "fD_MZ";
export var formInfo__title = "fD_M1";